import { useSelector } from "react-redux";
import { RootState } from "../../state";
import {
  IconButton,
  Typography,
  Dialog as DialogReact,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
} from "@mui/material";
import DigalogService from "./dialogService";
import CloseIcon from "@mui/icons-material/Close";

const Dialog = () => {
  const { close } = DigalogService();
  const dialogData = useSelector((state: RootState) => state.dialog);

  const handleDialogClose = () => {
    close();
  };

  return (
    <>
      {dialogData.dialogs.map((dialog, index) => (
        <DialogReact
          key={index}
          open={dialog.open}
          onClose={handleDialogClose}
          scroll={dialog.scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          maxWidth={dialog.size}
          fullWidth={true}
          style={{
            zIndex: index + 1300 + " !important",
          }}
          sx={{
            "& .MuiDialog-paper": {
              margin: { xs: "1rem !important", sm: "2rem !important" },
              width: "100%",
            },
          }}
        >
          <DialogTitle
            id="scroll-dialog-title"
            sx={{
              display: "flex",
              alignItems: "center",
              paddingRight: "5px",
              height: "fit-content",
              minHeight: "70px",
              fontSize: { xs: "1.2rem !important", sm: "1.5rem !important" },
              fontWeight: "700 !important",
            }}
          >
            {dialog.title}
            <IconButton onClick={handleDialogClose} sx={{ ml: "auto" }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {typeof dialog.content === "string" ? (
              <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
                <Typography variant="body1" style={{ whiteSpace: "pre-wrap" }}>
                  {dialog.content}
                </Typography>
              </DialogContentText>
            ) : (
              dialog.content
            )}
          </DialogContent>
          {dialog.actions.length > 0 ? (
            <DialogActions>
              {dialog.actions.map((elem, index) => (
                <Box key={index}>{elem}</Box>
              ))}
            </DialogActions>
          ) : (
            ""
          )}
        </DialogReact>
      ))}
    </>
  );
};

export default Dialog;
